export default "__VITE_ASSET__Nb1uSXSN__"